import * as React from 'react';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Grid from '@components/basics/grid';
import Typography from '@components/basics/typography';

interface ErrorMessageProps {
  className?: string;
  errorId?: string;
  message?: React.ReactNode;
  hasBackground?: boolean;
  fallback?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  className,
  errorId,
  message,
  hasBackground,
  fallback,
}) => {
  return errorId || message ? (
    <Grid
      gap={5}
      className={`${className || ''} ${hasBackground ? 'has-background' : ''}`}
    >
      <ErrorType className="error-message" type="small" weight="700">
        <Translate
          id={errorId}
          options={
            fallback
              ? {
                  onMissingTranslation: () => fallback,
                  renderToStaticMarkup: false,
                }
              : undefined
          }
        />
      </ErrorType>
      {message && (
        <ErrorType className="error-message" type="small">
          {message}
        </ErrorType>
      )}
    </Grid>
  ) : null;
};

export default styled(ErrorMessage)`
  &.has-background {
    padding: 30px;
    border-radius: 10px;
    background-color: ${({ theme }) => theme.colors.pink};

    .error-message {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const ErrorType = styled(Typography)`
  color: ${({ theme }) => theme.colors.error};
`;
